import React, {Component, Fragment} from 'react';


import Backdrop from '@mui/material/Backdrop';

//import Dialog, {DialogTitle,DialogContent, DialogContentText, DialogActions} from '@mui/material/Dialog';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Typography } from '@mui/material';

const s:any = {
  button: {
    m: 1
  },
  hidden: {
    display: 'none'
  },
  visible: {
    display: 'block'
  },
  progress: {
    margin: 'spacing(4)',
    backgroundColor: 'transparent'
  },
  dialogcontent: {
    backgroundColor: 'white'
  },
  backdrop: {
    zIndex: 'zIndex.drawer + 1',
    color: '#fff',
  },
  alertdiv: {
    width: 400,
    height: 400,
    '& > * + *': {
      marginTop: 'spacing(2)',
    },
  }
};

class Message extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
    };
  }

  render() {
    const {open,title,message,type,onClose,classes} = this.props;
    // const dialogClasses = {
    //   paper: classes.dialogcontent
    // }
    return (
      <Fragment>
        <Backdrop open={open} sx={{...s.backdrop}} onClick={onClose}>
        <Dialog open={open}  sx={{...s.dialogcontent}} > {/*classes={dialogClasses} */}
          <DialogContent sx={{...s.dialogcontent}}>
          
          <Alert severity={type}>
            <AlertTitle>{title}</AlertTitle>
              <Typography variant={'body1'}>{message}</Typography>
          </Alert>
          </DialogContent>
          {/* <DialogActions>
            <Button variant="contained" color="secondary" onClick={onClose}><CloseIcon/> </Button>
          </DialogActions> */}
        </Dialog>
        </Backdrop>
      </Fragment>
    );
  }
}

export default Message;
